module.exports = __webpack_public_path__ + "img/solution-opration-banner.e57826c7.png";